import React from "react";
import {ICardStrategy} from "../card.strategy.interface";
import {BookingModel} from "../../../../../booking.model";
import {
    SupportedCardNetworksLargeComponent
} from "../../../../../../../../pages/booking-flow/payment/card/supported-card-networks-large.component";

export class ApcopayCardStrategy implements ICardStrategy {
    constructor(private readonly booking: BookingModel) {

    }

    renderTabContent(): React.ReactElement {
        return (
            <SupportedCardNetworksLargeComponent networks={this.booking.paymentHandler.cardPaymentMethod.networks}/>
        )
    }

    async startPayment(): Promise<void> {
        await this.booking.paymentHandler.startBookingPayment({
            paymentMethodCode: this.booking.paymentHandler.cardPaymentMethod.code
        });
    }
}